import { DraftState } from '@/types';
import { getSelectedSizes } from '@/model/draft/getSelectedSizes';

export const setSizeQuantityAction = (sizeId: string, quantity: number) => (draft: DraftState) => {
  const selectedSize = getSelectedSizes(draft);
  if (quantity === 0 && selectedSize[sizeId]) {
    delete selectedSize[sizeId];
  } else {
    selectedSize[sizeId] = quantity;
  }
};
